import { Component, OnInit } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ValidationService } from '../services/validation.service';

@Component({
  selector: 'app-reset',
  templateUrl: './reset.component.html',
  styleUrls: ['../_auth.scss']
})
export class ResetComponent implements OnInit {
  public resetForm: FormGroup;
  public formErrMsg: string;
  public resetRequestSubmitted: boolean;

  constructor(
    private authService: AuthService,
    private formBuilder: FormBuilder,
    private validationService: ValidationService
  ) {
    this.resetForm = this.formBuilder.group({
      email: ['', [this.validationService.emailValidator, this.validationService.spaceChecker]],
    });
  }

  ngOnInit() {
    this.resetForm.valueChanges.subscribe(data => this.formErrMsg = null);
  }

  submitRequest() {
    this.resetForm.controls.email.markAsTouched();
    if (!this.resetForm.valid) { return; }
    this.authService.requestReset(this.resetForm.value).subscribe(
      response => this.resetRequestSubmitted = true,
      error => this.formErrMsg = error.error.errorMessage
    );
  }
}

